"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @uifabric/styling@6.50.6
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
var set_version_1 = require("@uifabric/set-version");
set_version_1.setVersion('@uifabric/styling', '6.50.6');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib-commonjs/version.js
// module id = 591
// module chunks = 0